import { Capacitor } from '@capacitor/core';

/**
 * Detect if the app is running in a native mobile environment (Capacitor)
 */
export const isNativeMobileApp = (): boolean => {
  // Dev-only escape hatch: `localStorage.setItem('ugForceMobile', 'true')` +
  // reload renders the mobile app tree in a desktop browser. The NODE_ENV
  // check is compile-time, so production builds strip this branch entirely.
  if (
    process.env.NODE_ENV === 'development' &&
    typeof localStorage !== 'undefined' &&
    localStorage.getItem('ugForceMobile') === 'true'
  ) {
    return true;
  }
  return Capacitor.isNativePlatform();
};

/**
 * Get the current platform name
 */
export const getPlatform = (): string => {
  return Capacitor.getPlatform();
};

/**
 * Check if running on a specific platform
 */
export const isPlatform = (platform: string): boolean => {
  return Capacitor.getPlatform() === platform;
};
